import React, { useMemo } from 'react'
import useReduxData from './useReduxData';
import useSelectedStore from './useSelectedStore';

const useLogoFevIcon = () => {
    const { selectedStore, isStoreSelected, allStore } = useSelectedStore();

    const logo = useMemo(() => {
        let store_image = selectedStore?.store_image;
        const storeId = selectedStore?.store_id || "";
        if (!storeId && allStore?.length > 0) {
            store_image = allStore[0]?.store_data?.store_image
        }
        let url = store_image ? store_image?.base_url + store_image?.attachment_url : "/images/Yop_Logo.png";
        return url


    }, [selectedStore, allStore])
    const fevicon = useMemo(() => {
        let fevIconInfo = selectedStore?.favicon
        const storeId = selectedStore?.store_id || "";
        if (!storeId && allStore?.length > 0) {
            fevIconInfo = allStore[0]?.store_data?.favicon
        }
        let fevIconUrl = fevIconInfo ? `${fevIconInfo?.base_url}${fevIconInfo?.attachment_url}` : "/images/Yop_Logo.png";
        return fevIconUrl;
    }, [selectedStore, allStore])

    return { logo, fevicon }
}

export default useLogoFevIcon